import type { Endpoint, Request, RequestArgs, Route } from '../types.no-deps'
import type { UUID } from '../../../shared/lib/typeHelpers.no-deps'

export const route: Route = { method: 'DELETE', pattern: '/api/posts/comments/:id' }

type Params = { id: UUID }
type Body = never
type Query = never
type Output = never

export type RemoveCommentEndpoint = Endpoint<Params, Body, Query, Output>

export const removeCommentRequest = (request: Request, args: RequestArgs<RemoveCommentEndpoint>) =>
    request<RemoveCommentEndpoint>(route, args)
